import React from "react";
import { Alert, Box, SpaceBetween } from "@cloudscape-design/components";
import { LABELS } from "../../constants";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error(LABELS.RENDER_ERROR_HEADER, error, errorInfo);
  }

  render(): React.ReactNode {
    if (this.state.error) {
      return (
        <Alert type="error" header={LABELS.RENDER_ERROR_HEADER}>
          <SpaceBetween size="xs">
            <Box>{LABELS.RENDER_ERROR_MESSAGE}</Box>
            <Box variant="code">{this.state.error.message}</Box>
          </SpaceBetween>
        </Alert>
      );
    }
    return this.props.children;
  }
}
